module.exports = __webpack_public_path__ + "static/media/Mareanie_gaussian2.62dcf64c.png";